import { useQuery } from '@tanstack/react-query';
import { useCheckUserLoggedIn } from '../../../user/useCheckUserLoggedIn';
import { getUserSellTractors } from '../../../../api/user/queries/getUserSellTractors';
import { IOpenMarketProduct } from '../../../../interfaces/Product.interfaces';

export const useGetUserSellTractors = () => {
  const { isUserLoggedIn } = useCheckUserLoggedIn();

  return useQuery<IOpenMarketProduct[]>(['user_sell_tractors/mine'], () => getUserSellTractors(), {
    enabled: isUserLoggedIn,
  });
};
